import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { categorySourceReducer } from "./categorySourceReducer";
import { commonReducer } from "./commonReducer";
import { dictionaryReducer } from "./dictionaryReducer";
import { localizedResourceReducer } from './localized-resource/localizedResourceReducer';
import { notifyReducer } from './notify/notifyReducer';
import { uploadReducer } from './upload-file/uploadReducer';
import { appConfigReducer } from "./common/appConfigReducer";
import { foCaAnReducer } from "./thuc-don/foCaAnReducer";
import { foCaAnTruongReducer } from "./thuc-don/foCaAnTruongReducer";
import { foMonAnChiTietReducer } from "./thuc-don/foMonAnChiTietReducer";
import { foThucDonReducer } from "./thuc-don/foThucDonReducer";
import { foDotDangKyAnReducer } from "./thuc-don/foDotDangKyAnReducer";
import { foDotDangKyPhamViReducer } from "./thuc-don/foDotDangKyPhamViReducer";
import { foDangKyAnHocSinhReducer } from "./thuc-don/foDangKyAnHocSinhReducer";
import { danhMucReducerWrapper } from "./danh-muc/danhMucReducerWrapper";
const reducers = combineReducers({
    auth: authReducer,
    appConfig: appConfigReducer,
    dictionary: dictionaryReducer,
    categorySource: categorySourceReducer,
    common: commonReducer,
    uploadFile: uploadReducer,
    notify: notifyReducer,
    localizedResource: localizedResourceReducer,
    thucDonWrapper: combineReducers({
        caAn: foCaAnReducer,
        caAnTruong: foCaAnTruongReducer,
        monAnChiTiet: foMonAnChiTietReducer,
        thucDon: foThucDonReducer,
        dotDangKyAn: foDotDangKyAnReducer,
        dotDangKyPhamVi: foDotDangKyPhamViReducer,
        dangKyAnHocSinh: foDangKyAnHocSinhReducer
    }),
    danhMucWrapper: danhMucReducerWrapper,
   
})

export default reducers

export type RootState = ReturnType<typeof reducers>